import { render, staticRenderFns } from "./HotelLayout.vue?vue&type=template&id=ee81d94e"
import script from "./HotelLayout.vue?vue&type=script&lang=js"
export * from "./HotelLayout.vue?vue&type=script&lang=js"
import style0 from "./HotelLayout.vue?vue&type=style&index=0&id=ee81d94e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports